/**
 * Chat abstraction layer
 *    - Provides a unified interface for chat functionality
 *    - Swap providers by changing the getter
 *    - 3rd-party script gets injected via gatsby-ssr.js
 */

const chat = {
  get api() {
    return typeof window !== "undefined" ? window?.drift?.api : null;
  },

  show: () => chat.api?.widget?.show?.(),
  hide: () => chat.api?.widget?.hide?.(),
  open: () => chat.api?.openChat?.(),
  isAvailable: () => !!chat.api,
};

export default chat;
